export default function (err) {
    if (err.response.data.error) return err.response.data.error;
    let string = null;
    let errors = err.response.data.errors || [];
    string = `${err.response.data.message}<br/>`;
    for (let i in errors) {
        string += `${errors[i]}<br/>`;
    }
    return string;
}